import { colors } from '@ardoq/design-tokens';
import { Icon, IconName, IconSize } from '@ardoq/icons';
import { t, type I18nLocale, DEFAULT_ARDOQ_I18NLOCALE } from '@ardoq/i18n';
import { FlexBox } from '@ardoq/layout';
import { Text } from '@ardoq/typography';
import { ReactNode } from 'react';

export type AiDisclaimerProps = {
  i18nLocale?: I18nLocale;
  text?: string;
};

export const AiDisclaimer = ({
  i18nLocale = DEFAULT_ARDOQ_I18NLOCALE,
  text,
}: AiDisclaimerProps): ReactNode => {
  const resolvedText =
    text ??
    t(
      i18nLocale,
      'ai:aiDisclaimer.defaultText',
      'Always verify important AI-generated information'
    );
  return (
    <FlexBox align="center" gap="xsmall" paddingTop="small">
      <Icon
        iconSize={IconSize.SMALL}
        color={colors.icon}
        iconName={IconName.INFO}
      />
      <Text variant="caption" color="textSubtle">
        {resolvedText}
      </Text>
    </FlexBox>
  );
};
